/**
 * Converts a URLSearchParams instance to a readable query string.
 *
 * URLSearchParams encodes brackets and commas by default, which makes
 * structured filter params like `field[like]=value` or `field[in]=a,b`
 * unreadable in the URL. This function decodes them back to literal characters.
 *
 * @example
 * toQueryString(new URLSearchParams({ 'name[like]': 'Alice' }))
 * // → 'name[like]=Alice'
 */
export function toQueryString(qs: URLSearchParams): string {
  return qs
    .toString()
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
    .replace(/%2C/gi, ',');
}
